module.exports = __webpack_public_path__ + "static/pic01-6fcd49672cfc7d5d2cc57010a7d48427.jpeg";